<template>
    <div>
        <el-table
            ref="address-bundle-table"
            v-loading="loadingBundles"
            :data="bundles"
            class="w-full"
            stripe
        >
            <!-- Information Column -->
            <el-table-column
                prop="sid"
                label="Information"
                width="320"
            >
                <template v-slot="scope">
                    <InformationColumn
                        :row="scope.row"
                        :show-customer-profile="false"
                        :show-regulatory-bundle="true"
                        name-field="friendly_name"
                    />
                </template>
            </el-table-column>

            <!-- Timestamps Column -->
            <el-table-column
                label="Timestamps"
                width="140"
            >
                <template v-slot="scope">
                    <TimestampsColumn :row="scope.row" />
                </template>
            </el-table-column>

            <!-- Customer Name Column -->
            <el-table-column
                label="Customer Name"
                prop="customer_name"
                width="180"
            >
                <template v-slot="scope">
                    <span v-if="scope.row.customer_name">{{ scope.row.customer_name }}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>

            <!-- Address Details Column -->
            <el-table-column
                label="Address Details"
            >
                <template v-slot="scope">
                    <div v-if="hasAddressInformation(scope.row)">
                        <!-- Row 1: Street and Street Secondary -->
                        <el-row :gutter="10">
                            <el-col :span="12">
                                <p class="mb-0 font-weight-bold">Street:</p>
                                <p class="mb-0">{{ scope.row.street || '-' }}</p>
                            </el-col>
                            <el-col :span="12">
                                <p class="mb-0 font-weight-bold">Street Secondary:</p>
                                <p class="mb-0">{{ scope.row.street_secondary || '-' }}</p>
                            </el-col>
                        </el-row>
                        
                        <!-- Row 2: City and Region/State -->
                        <el-row :gutter="10" class="mt-2">
                            <el-col :span="12">
                                <p class="mb-0 font-weight-bold">City:</p>
                                <p class="mb-0">{{ scope.row.city || '-' }}</p>
                            </el-col>
                            <el-col :span="12">
                                <p class="mb-0 font-weight-bold">Region/State:</p>
                                <p class="mb-0">{{ scope.row.region || '-' }}</p>
                            </el-col>
                        </el-row>
                        
                        <!-- Row 3: Postal Code and Country -->
                        <el-row :gutter="10" class="mt-2">
                            <el-col :span="12">
                                <p class="mb-0 font-weight-bold">Postal Code:</p>
                                <p class="mb-0">{{ scope.row.postal_code || '-' }}</p>
                            </el-col>
                            <el-col :span="12">
                                <p class="mb-0 font-weight-bold">Country:</p>
                                <p class="mb-0">{{ scope.row.iso_country || '-' }}</p>
                            </el-col>
                        </el-row>
                    </div>
                    <span v-else>No address information available</span>
                </template>
            </el-table-column>

            <!-- Status Column (Combined Emergency and Validation Status) -->
            <el-table-column
                label="Status"
            >
                <template v-slot="scope">
                    <div>
                        <p class="mb-0 font-weight-bold">Emergency:</p>
                        <p class="mb-0">{{ scope.row.emergency_enabled ? 'Yes' : 'No' }}</p>
                    </div>
                    <div class="mt-1">
                        <p class="mb-0 font-weight-bold">Validated:</p>
                        <p class="mb-0">{{ scope.row.validated ? 'Yes' : 'No' }}</p>
                    </div>
                    <div class="mt-1">
                        <p class="mb-0 font-weight-bold">Verified:</p>
                        <p class="mb-0">{{ scope.row.verified ? 'Yes' : 'No' }}</p>
                    </div>
                </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column
                label="Action"
                width="150"
            >
                <template v-slot="scope">
                    <div class="mt-1">
                        <el-button
                            type="danger"
                            size="mini"
                            class="btn-block"
                            @click="handleDeleteBundle(scope.row)"
                            :loading="loadingDeleteBundle.includes(scope.row.id)"
                        >
                            Delete
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import InformationColumn from '../columns/information-column'
import TimestampsColumn from '../columns/timestamps-column'

export default {
    name: 'AddressBundleTable',
    components: {
        InformationColumn,
        TimestampsColumn,
    },
    props: {
        bundles: {
            type: Array,
            required: true,
        },
        loadingBundles: {
            type: Boolean,
            required: true,
        },
        company: {
            type: Object,
            required: true,
        },
        loadingUpdateBundle: {
            type: Array,
            default: () => [],
        },
        loadingDeleteBundle: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        hasAddressInformation(row) {
            return row.street || 
                  row.street_secondary || 
                  row.city || 
                  row.region || 
                  row.postal_code || 
                  row.iso_country
        },
        handleDeleteBundle(bundle) {
            this.$emit('delete-bundle', bundle)
        },
    },
}
</script>
